export default __webpack_public_path__ + "static/media/itemA.df79ff2f.gif";